import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Loader from '../../../components/Loader'
import LoadMore from '../../../components/LoadMore'
import styles from '../../../constants/styles'
import { _ } from '../../../utils/localization'
import {
    loadMore,
    selectVideo,
    videosSelector,
    canLoadMoreSelector,
    fetchVideosStatusSelector
} from '../cinemaSlice'
import MovieThumbnail from './MovieThumbnail'

const S = {
    Sidebar: styled.div`
        position: fixed;
        top: ${styles.topNavHeight}px;
        right: 0;
        width: ${styles.sidebarWidth}px;
        height: calc(100% - ${styles.topNavHeight}px - 10px);
        padding: 0 20px 10px 20px;
        background-color: rgba(45, 48, 53, 0.8);
        overflow: auto;
        @media (max-width: 1366px) {
            width: ${styles.smallerSidebarWidth}px;
        }
    `,
    Title: styled.h3`
        margin: 20px 0;
        font-size: 21px;
        font-weight: 500;
        color: white;
    `,
    Divider: styled.div`
        width: 100%;
        height: 1px;
        margin: 6px 0;
        background-color: rgba(255, 255, 255, 0.1);
    `
}

const Sidebar = () => {
    const dispatch = useDispatch()
    const videos = useSelector(videosSelector)
    const canLoadMore = useSelector(canLoadMoreSelector)
    const requestStatus = useSelector(fetchVideosStatusSelector)

    return (
        <S.Sidebar>
            <S.Title>{_('cinema.sidebar.title')}</S.Title>
            {videos.map((item) => (
                <Fragment key={item.id}>
                    <S.Divider key={item.id} />
                    <MovieThumbnail
                        key={`_${item.id}`}
                        item={item}
                        onClick={() => dispatch(selectVideo(item.id))}
                    />
                </Fragment>
            ))}
            {requestStatus === 'loading' && <Loader color="white" isCenter />}
            {canLoadMore && (
                <LoadMore
                    variant="light"
                    onClick={() => dispatch(loadMore())}
                    style={{ borderTop: '1px solid rgba(255, 255, 255, 0.3)', marginTop: 10 }}
                >
                    {_('cinema.videos.loadmore')}
                </LoadMore>
            )}
        </S.Sidebar>
    )
}

export default Sidebar
